import type { TranslationsType } from "../types/TranslationsType"

export const enTranslations: TranslationsType = {
  header: {
    title: "Configuration Management Tool",
    logout: "Logout"
  },
  globalNavigation: {
    customers: "Customers",
    home: "Home"
  },
  customers: {
    pageTitle: "Customers",
    searchPlaceholder: "Search by name",
    noCustomersFound: "No customers found",
    table: {
      name: "Name",
      salesforceId: "Salesforce ID",
      id: "UUID",
      taxNumber: "Tax number",
      rows: "Rows",
      openConfiguration: "Open table configuration",
      subType: "Relationship subtype",
      relationshipType: "Relationship type",
      customer: "Customer",
      billingEntity: "Billing entity",
      formerCustomer: "Former customer",
      customersAffiliate: "Customer's affiliate",
      sdmEmail: "SDM email"
    },
    tableManager: {
      previewTooltipWarning: "Close the table configuration in order to interact with the view",
      cancelBtn: "Cancel",
      saveBtn: "Save",
      closePreviewBtn: "Close Preview",
      showPreviewBtn: "Preview {{count}} changes",
      newGroup: "New Group",
      newGroupTooltip: "Add a new column group",
      columnManagerSubtitle: "Table configuration",
      optionsTitle: "Available Parameters",
      confirmSaveBtn: "Save",
      confirmSaveCancelBtn: "Cancel",
      confirmSaveTitle: "Save table configuration?",
      confirmSaveMessage:
        "The changes will be saved to your browser's local storage and will persist across sessions. These settings are specific to your browser and will not affect other users."
    },
    loading: {
      text: "Loading customers..."
    }
  },
  home: {
    pageTitle: "Welcome to Configuration Management Tool"
  },
  login: {
    pageTitle: "Configuration Management Tool",
    subtitle: "You're not signed in. Please sign in again to continue.",
    msalOption: "Microsoft Entra ID (preferred)",
    signInMsal: "Sign in with Microsoft Entra ID",
    signInOidc: "Sign in with OIDC Identity Server",
    alreadySignedIn: "You are already signed in.",
    goToHome: "Go to Home",
    msalFailureTitle: "Microsoft Entra ID Sign-in Failed",
    msalFailureMessage:
      "Unable to sign in with Microsoft Entra ID. You can try signing in with the OIDC Identity Server instead."
  },
  customer: {
    tabs: {
      overview: "Overview",
      planresources: "Plan resources"
    },
    overview: {
      customerTime: "Customer time",
      linksTitle: "Links",
      descriptionTitle: "About customer",
      hierarchyTitle: "Hierarchy",
      modulesTitle: "Modules",
      noModules: "Customer has no modules",
      modulesNoAccess: "This information is not available to you.",
      noRelatedCustomers: "No related customers found",
      loadingHierarchy: "Loading customer hierarchy...",
      noDescription: "No description available for this customer.",
      generateDescription: "Generate AI Description",
      descriptionError: "Failed to generate description. Please try again later."
    }
  },
  visualization: {
    creatingGraph: "Creating graph...",
    billingEntity: "Billing entity",
    error: {
      neighboringNodesForNode: "Failed to load neighboring nodes for {{nodeName}}",
      neighboringNodes: "Failed to load neighboring nodes",
      retry: "Retry",
      unknown: "An unknown error occurred"
    },
    nodePropertiesDisplay: {
      sidebarLocked: "Sidepanel locked",
      sidebarUnlocked: "Sidepanel unlocked",
      lockSidebar: "Lock sidebar",
      unlockSidebar: "Unlock sidebar",
      nodeProperties: "Node Properties",
      editParent: "Edit parent",
      editParentTitle: "Edit parent for {{nodeName}}",
      parent: "Parent",
      searchParentPlaceholder: "Search for parent...",
      noParentsFound: "No parents found",
      searchResults: "Search results",
      currentParent: "{{name}} (current parent)",
      selectParent: "Select {{name}} as parent"
    },
    toast: {
      parentUpdated: {
        title: "Parent updated successfully",
        message: "Plan customer {{customerName}} has moved to {{parentName}}.",
        viewLink: "View",
        planResources: "Plan resources graph"
      },
      parentUpdateFailed: {
        title: "Failed to update {{customerName}}",
        errorPrefix: "Error:",
        forbidden: "You do not have permission to update the parent relationship"
      }
    }
  },
  unauthorized: {
    pageTitle: "Access Required",
    description: "You don't have access to use this application. Request ID: {{subId}}.",
    button: "Retry",
    requestButtonLabel: "Request Access",
    requestedButtonLabel: "Access Requested",
    requestSuccessTitle: "Access request sent.",
    requestSuccessDescription: "The team will review your request.",
    requestErrorTitle: "Failed to send access request.",
    requestErrorDescription:
      "Please try again later. If the problem persists, contact the tech-cmdb-feedback Slack channel."
  },
  errorBoundary: {
    pageTitle: "Sorry, an unexpected error has occurred.",
    defaultDescription: "An unexpected error has occurred.",
    button: "Retry"
  },
  vpnError: {
    pageTitle: "Connection Issue",
    description: "This might be related to VPN connectivity. Try the following steps:",
    step1: "Connect to the company VPN",
    step2: "Wait for stable connection",
    step3: "Refresh the page",
    technicalDetails: "Show technical details"
  },
  general: {
    close: "Close",
    cancel: "Cancel",
    save: "Save"
  },
  sessionRecovery: {
    title: "Session Expired",
    message: "Your session has expired. Click Resume to sign in again and continue where you left off.",
    resume: "Resume",
    resuming: "Signing in..."
  },
  dynamicForm: {
    loading: "Loading form...",
    loadError: "Failed to load form",
    menuTitlesLoadError: "Failed to load available forms for this customer.",
    noViewAccessTitle: "Form not available",
    noViewAccess: "This form is not available for this customer, or you lack the permissions to view it.",
    noDeploymentAccess: "You do not have permission to create deployments for this customer."
  }
}
